export const AuthTokenCookieName: string = 'BearerToken';
export const AuthRootTokenCookieName: string = 'RootBearerToken';
export const AuthInstanceCodeCookieName: string = 'BearerInstanceCode';

export const AuthTokenTTLDays: number = 14;
